import {ApplicationConfig, provideAppInitializer} from '@angular/core';
import {inject,provideBrowserGlobalErrorListeners, provideZonelessChangeDetection,} from '@angular/core';
import {
  NoPreloading,
  provideRouter,
  Router,
  withComponentInputBinding,
  withInMemoryScrolling,
  withPreloading,
  withRouterConfig,
  TitleStrategy
} from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';

import { appRoutes } from './app.routes';
import { authenticationInterceptor } from '~core/interceptors/authentication.interceptor';
import { ENVIRONMENT } from '~core/tokens/environment.token';
import { environment } from '~environments/environment';
import {
  provideClientHydration,
  withEventReplay,
  withIncrementalHydration,
} from '@angular/platform-browser';
import { provideNgToast } from 'ng-angular-popup';
import {provideTranslateService,} from "@ngx-translate/core";
import {provideTranslateHttpLoader} from "@ngx-translate/http-loader";
import {AppTitleStrategy} from "~core/services/title-strategy.service";
import {SessionService} from "~core/services/session.service";
import { pendingRequestsInterceptor$ } from 'ng-http-loader';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: ENVIRONMENT,
      useValue: environment,
    },
    provideZonelessChangeDetection(),
    provideNgToast(),
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(
        withFetch(),
        withInterceptors([authenticationInterceptor,pendingRequestsInterceptor$]),
    ),
    provideTranslateService({
      lang: "DEFAULT_LOCALE",
      fallbackLang: "DEFAULT_LOCALE",
      loader: provideTranslateHttpLoader({
        prefix: '/i18n/',
        suffix: '.json'
      })
    }),
    provideAppInitializer(() => {
      const  sessionService = inject(SessionService);
      const Lang = sessionService.CurrentLanguage();
      //console.log("IL linguaggio di default e' "+Lang);
      sessionService.setCurrentLanguage(Lang);
    }),
    provideRouter(
        appRoutes,
        withInMemoryScrolling(),
        withComponentInputBinding(),
        withRouterConfig({ paramsInheritanceStrategy: 'always', onSameUrlNavigation: 'reload' }),
        withPreloading(NoPreloading),
    ),
    provideClientHydration(withEventReplay(), withIncrementalHydration()),
    {provide: TitleStrategy, useClass: AppTitleStrategy}
  ],
};
